import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("Quote", {
  title: "Quote",
  hideInSelectionDialogs: true,
  properties: ["title", "image", "content", "author", "function"],
  initialContent: {
    title: "Lorem Ipsum",
    content:
      "<q>Weit hinten, hinter den Wortbergen, fern der Länder Vokalien und Konsonantien leben die Blindtexte. Abgeschieden wohnen sie in Buchstabhausen an der Küste des Semantik, eines großen Sprachozeans. Ein kleines Bächlein namens Duden fließt durch ihren Ort und versorgt sie mit den nötigen Regelialien. Es ist ein paradiesmatisches Land, in dem einem gebratene Satzteile in den Mund fliegen.</q>",
    author: "Peter-Paul-Gustav von Entenhausen",
  },
});
